<div>
    <app-header></app-header>
</div>
<div class="main">
    <!-- <div *ngIf="!myProfile" class="d-flex mb-3 back">
        <img (click)="goBack()" src="assets/images/arrow-circle-left.svg">
        <h3 (click)="goBack()" class="ms-2 mb-0">Back</h3>
    </div> -->
    <div Class="row m-0 ">
        <!-- <div class="col-lg-2 p-0 profile mt-0 position-relative">
            <app-profile-front-page></app-profile-front-page>
        </div> -->
        <div class="col-lg-12 bg-white py-sm-3 py-md-3 pb-0">
            <!-- <app-menu-card></app-menu-card> -->
            <div class="upperimgdata bg-white">
                <div class="change-password-container">
                    <div class="d-flex flex-column">
                        <h4>{{ aboutUsData.title || 'About Us' }}</h4>
                        <span><b class="bld-text">Settings<span class="mx-2">/</span></b><span class="semi-bld-text">{{
                                aboutUsData.title || 'About Us' }}</span></span>
                    </div>
                    <div class="d-flex flex-column aboutus_layout">
                        <div class="header_img">
                            <img src="/assets/images/Header.png" alt="header_img" />
                        </div>
                        <!-- <div class="aboutus_content">
                            <p>
                                <span>{{ aboutUsData.short_description || 'Loading description...' }}</span>
                                <br><br>
                                <span>{{ aboutUsData.description || 'Loading full description...' }}</span>
                            </p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div>



    <header class="lead-section text-center py-md-5 pt-0">
        <h1> Welcome to EFL-RAFTAARR </h1>
        <p class="lead"> <strong>Laye aapke Business mein Raftaarr</strong> </p>
        <p class="px-3 px-sm-0">Your Gateway to Transformative Growth for Manufacturing Businesses!

            Imagine a world where growing and managing your manufacturing business is as seamless as a click. With
            EFL-RAFTAARR, that vision becomes a reality. As India’s first digital ecosystem for Industrial MSMEs, we’re
            revolutionizing how businesses like yours operate. From enhancing your network to streamlining operations
            and accessing tailored solutions, everything you need is now in one place. </p>
    </header>


    <section class="container my-sm-5 my-md-5 mb-0">
        <h2 class="text-center mb-4">Offerings & Benefits </h2>
        <p class="text-center">With EFL-RAFTAARR, every aspect of your manufacturing business is supported, giving you
            the tools to grow faster, smarter, and more efficiently. </p>
        <ul>
            <li><strong>Marketplace for Manufacturing MSMEs: </strong> buy, sell, or upgrade industrial machinery to the
                latest versions. </li>
            <li> <strong> Flexible Financing: </strong>Unlock tailored loan solutions designed to boost your
                manufacturing business. </li>
            <li><strong> Production Support: </strong>Simplify the process of sourcing raw materials, hiring skilled
                labour, or outsourcing production orders. </li>
            <li><strong> Industrial Spaces: </strong>Find manufacturing or expansion spaces with ease. </li>
            <li><strong>Business Networking: </strong>Forge meaningful partnerships, connect with peers, and grow
                together.</li>
        </ul>
    </section>


    <section class="container mb-0 my-sm-5 my-md-5">
        <h2 class="text-center mb-4">Why Choose Us? </h2>
        <p class="text-center">EFL-RAFTAARR isn’t just a platform—it’s a transformative ecosystem backed by decades of
            manufacturing expertise. Here’s how we help you stay ahead: </p>

        <ul>
            <li><strong> Innovative All-in-One Platform: </strong> Access every service your business needs under one
                roof. </li>
            <li><strong>Go Digital, Grow Faster:</strong> Transition to smarter, more efficient operations with our
                cutting-edge tools. </li>
            <li><strong>Quick Cost-Savings: </strong>Optimize costs and maximize profits with affordable, effective
                services. </li>
            <li><strong>Customized Solutions: </strong>Enjoy services tailored specifically to your unique business
                needs. </li>
            <li><strong>Backed by EFL’s Expertise: </strong>Benefit from over 30 years of industry knowledge and a
                proven track record.</li>
        </ul>
    </section>


    <section class="container mb-0 my-sm-5 my-md-5">
        <h2 class="text-center mb-4">Our Achievements </h2>
        <p class="text-center">EFL-RAFTAARR isn’t just a platform—it’s a transformative ecosystem backed by decades of
            manufacturing expertise. Here’s how we help you stay ahead: </p>

        <ul>
            <li>Over <strong>30 years of trusted expertise</strong> in the manufacturing sector. </li>
            <li> Supporting<strong> 40,000+ manufacturing customers </strong>nationwide. </li>
            <li> Thriving online community with <strong>15,000+ active members</strong>. </li>
            <li>Breaking barriers: Connecting<strong> global products</strong> to a national marketplace. </li>

        </ul>
    </section>


    <section class="container mb-0 my-sm-5 my-md-5">
        <div class="row">
            <div class="col-md-6">
                <h2 class="text-center mb-4">Vision </h2>
                <!-- <p class="text-center">To empower Industrial MSMEs with a comprehensive digital ecosystem that drives
                    growth, innovation, and seamless connections while fostering trust and transparency in every
                    interaction. </p> -->
                    <p class="text-center mb-4">
                        Create a globally connected industrial community.
                    </p>

            </div>
            <div class="col-md-6">
                <h2 class="text-center mb-4">Mission </h2>
                <!-- <p class="text-center">To revolutionize the manufacturing MSME landscape by creating a platform that
                    connects businesses with opportunities, enhances visibility, and ensures sustainable growth in a
                    digital-first world. </p> -->
                    <p class="text-center mb-4">
                        Empower manufacturers and suppliers to grow by fostering collaboration, efficiency, and innovation.
                    </p>
            </div>
        </div>
    </section>
    <section class="container mb-0 my-sm-5 my-md-5">
        <div class="row">
            <div class="col-md-12">
                <h2 class="text-center mb-4">Core Values </h2>

                <ul>
                    <li><strong>Innovation:</strong> Leveraging cutting-edge technology to enable growth. </li>
                    <li><strong>Empowerment:</strong> Providing tools and resources to unlock potential. </li>
                    <li><strong>Collaboration:</strong> Building partnerships that drive mutual success. </li>
                    <li><strong>Transparency & Integrity:</strong> Ensuring honesty and openness in every interaction.
                    </li>
                    <li><strong>Sustainability:</strong> Championing responsible and forward-looking business practices.
                    </li>
                    <li><strong>Customer-Centricity:</strong> Delivering value through solutions tailored to your needs.
                    </li>
                </ul>
            </div>

        </div>
    </section>


    <section class="container mb-5 my-sm-5 my-md-5">
        <h2 class="text-center mb-4">Our Leadership </h2>
        <div class="row">
            <div class="col-md-4 mb-3 mb-sm-3">
                <div class="boxss22">
                    <div class="image-circle-container mb-3">
                        <img src="/assets/images/image/EFL_MD_Vizyug_4.jpg" alt="Shilpa Pophale" class="circle-image">
                    </div>
                    <h4> Shilpa Pophale – MD & CEO, Electronica Finance Ltd. </h4>
                    <p class="text-center"> Ms. Shilpa Pophale has been a driving force behind EFL for over 21 years.
                        Since becoming CEO in 2003 and MD in 2006, she has spearheaded the company’s growth, increasing
                        its AUM from INR 600 million in FY 2005 to INR 37,780 million in FY 2024. Her customer-focused
                        approach has expanded EFL’s offerings to include working capital, property finance, rooftop
                        solar loans, and micro-LAP solutions.</p>
                    <a href="https://www.linkedin.com/in/shilpa-pophale-a1b2214/?originalSubdomain=in"
                        class="readonlyctA">View LinkedIn Profile</a>
                </div>
            </div>
            <div class="col-md-4 mb-3 mb-sm-3">
                <div class="boxss22">
                    <div class="image-circle-container mb-3">
                        <img src="/assets/images/image/Ashutosh-Puntambekar.jpg" alt="Ashutosh Puntambekar" class="circle-image">
                    </div>
                    <h4> Ashutosh Puntambekar – Chief of Staff & Head, Sustainability </h4>
                    <p class="text-center"> With over 20 years of expertise in commercial banking and SME sectors, Mr.
                        Ashutosh Puntambekar leads key strategic initiatives at EFL. He oversees sustainability
                        programs, strategy, and marketing while heading the rooftop solar finance division. His efforts
                        have driven significant progress in environmental sustainability and financial inclusion.
                    </p>
                    <a href="https://www.linkedin.com/in/ashutosh-puntambekar-48727166/" class="readonlyctA">View
                        LinkedIn Profile</a>
                </div>
            </div>
            <div class="col-md-4">
                <div class="boxss22">
                    <div class="image-circle-container mb-3">
                        <!-- <img src="/assets/images/image/EFL_MD_Vizyug_4.jpg" alt="Shilpa Pophale" class="circle-image"> -->
                        <img src="/assets/images/image/Anshul.jpeg" alt="Anshul Sharma" class="circle-image">
                    </div>
                    <h4> Anshul Sharma – Business Head</h4>
                    <p class="text-center"> Anshul Sharma brings over 15 years of diverse experience in the financial
                        services sector, specializing in MSME and retail businesses. As the Business Head, he plays a
                        pivotal role in driving growth and operational excellence at EFL-RAFTAARR. His strategic
                        leadership and in-depth understanding of the MSME ecosystem have been instrumental in expanding
                        the platform's reach and impact.
                    </p>
                    <a href="https://www.linkedin.com/in/anshulvas/" class="readonlyctA">View LinkedIn Profile</a>
                </div>
            </div>
        </div>
    </section>
    <footer class="bg-dark text-white text-center py-4 px-2 px-sm-0" style="background: #eeeeee !important;
    margin-bottom: 30px;">
        <p>Your business growth starts here. <strong>Laye aapke Business mein Raftaarr</strong>, EFL-RAFTAARR is more
            than a platform; it’s a community where Industrial MSMEs find opportunities, solutions, and success—all in
            one place.</p>
        <a href="#" class="btn btn-primary" style="    background: #EE7402 !important;
    border: #EE7402;">Get Started with EFL-RAFTAARR Today!</a>
    </footer>
    <app-footer></app-footer>
</div>